import React, { forwardRef } from 'react';
import styled from 'styled-components';
import {
  ButtonPrimary,
  screenXsMin,
  screenSmMin,
  screenMdMin,
} from '@spotify-internal/encore-web';

import {
  COLOR_BLACK,
  COLOR_SPOTIFY_GREEN,
} from 'client/components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';

const VIDEO_DATA = {
  height: 546,
  width: 970,
  imagePath: 'videopartner/videopartner-video-placeholder-image',
  videoId: 't5sKpUgT5M4',
};

const VideoSection = styled.section`
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  padding: 60px 24px;

  @media (max-width: ${screenMdMin}) {
    padding: 0 52px 60px;
  }

  @media (max-width: ${screenXsMin}) {
    padding: 0 30px 60px;
  }
`;

const VideoTitle = styled.h2`
  margin-bottom: 80px;
  color: ${COLOR_BLACK};
  font-size: 3.125rem;
  line-height: 40px;
  text-align: center;

  @media (max-width: ${screenSmMin}) {
    max-width: 75%;
    margin: 0 auto 60px;
  }

  @media (max-width: ${screenXsMin}) {
    margin: 0 auto 30px;
    max-width: 100%;
    font-size: 2rem;
  }
`;

const VideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 58px;
  width: 100%;

  @media (max-width: ${screenSmMin}) {
    margin-bottom: 40px;
    width: 100%;
  }
`;

const CreateAccountPrompt = styled.p`
  margin: 0 0 24px;
  color: ${COLOR_BLACK};
  font-weight: bold;
  font-size: 1.125rem;
  line-height: 32px;
  text-align: center;

  @media (max-width: ${screenXsMin}) {
    font-size: 0.875rem;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  max-width: 215px;
  margin: 0 auto;
  button {
    div[class*='ButtonInner'] {
      color: ${COLOR_BLACK};
      background: ${COLOR_SPOTIFY_GREEN};
    }
  }
  button:hover {
    div[class*='ButtonInner'] {
      transform: scale(1.04);
      background: ${COLOR_SPOTIFY_GREEN};
    }
  }
`;

export const Video = forwardRef(({ onClick }: { onClick: () => void }, ref) => {
  const t = useT();

  return (
    <VideoSection>
      <VideoTitle>
        {t(
          'IntegrationConnectionScreen.Video.Title',
          'Upload to Anchor, watch on Spotify',
          'The title on the video section of the Integration Connection Screen'
        )}
      </VideoTitle>
      <VideoWrapper ref={ref}>
        <iframe
          title="Video Podcasts on Spotify"
          src="https://open.spotify.com/embed/episode/5NpUqphDklXv1dfQnCwXaw/video"
          width={VIDEO_DATA.width}
          height={VIDEO_DATA.height}
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        />
      </VideoWrapper>
      <CreateAccountPrompt>
        {t(
          'IntegrationConnectionScreen.Video.CreateAccountLoginPrompt',
          'Create an account or log in',
          'The prompt to encourage a user to create an Anchor account or log in on the Integration Connection Screen'
        )}
      </CreateAccountPrompt>
      <ButtonWrapper>
        <ButtonPrimary fullWidth colorSet="brightAccent" onClick={onClick}>
          {t('Button.GetStarted', 'Get started', 'Get started button text')}
        </ButtonPrimary>
      </ButtonWrapper>
    </VideoSection>
  );
});
